import { useTranslation } from 'react-i18next'

import { useDocFlowSendingWidgetNotifications } from '../../DocFlow.hooks'
import { DocFlowSendingWidgetProcessFieldName } from '../../DocFlowSending'
import { DocFlowSendingWidgetContent } from '../DocFlowSendingWidgetContent'

import {
  getDocFlowSendingResultPermanentNotifications,
  getDocFlowSendingResultWidgetNotifications,
} from './DocFlowSendingResultWidget.utils'

function DocumentStaplingSendingResultWidget({
  onClickPrevious,
  ...restProps
}) {
  const { t } = useTranslation()

  const widgetNotifications = getDocFlowSendingResultWidgetNotifications(t)

  const { notifications } = useDocFlowSendingWidgetNotifications({
    getInitialNotifications: getDocFlowSendingResultPermanentNotifications,
    phase: DocFlowSendingWidgetProcessFieldName.ResultsPhase,
    widgetNotifications,
  })

  function handleClickPrevious({ index }) {
    return onClickPrevious(index)
  }

  return (
    <DocFlowSendingWidgetContent
      {...restProps}
      notifications={notifications}
      widgetStatusFieldName={DocFlowSendingWidgetProcessFieldName.ResultsPhase}
      onClickPrevious={handleClickPrevious}
    />
  )
}

export default DocumentStaplingSendingResultWidget
